module.exports = __webpack_public_path__ + "img/cef8b723d683cc980945c6495fd84a23.png";